import { render } from "./IncomeItemsModal.vue?vue&type=template&id=e7be44f8&scoped=true"
import script from "./IncomeItemsModal.vue?vue&type=script&lang=js"
export * from "./IncomeItemsModal.vue?vue&type=script&lang=js"

import "./IncomeItemsModal.vue?vue&type=style&index=0&id=e7be44f8&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7be44f8"]])

export default __exports__